import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'glow';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-bold transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none uppercase tracking-wide';
  const variants = {
    primary: 'bg-[#064E3B] text-white hover:bg-[#065f49] focus:ring-[#064E3B]',
    secondary: 'bg-gray-800 text-white hover:bg-gray-700 focus:ring-gray-500',
    outline: 'border-2 border-[#064E3B] text-[#064E3B] hover:bg-[#064E3B]/10 focus:ring-[#064E3B]',
    glow: 'bg-[#064E3B] text-white hover:bg-[#065f49] focus:ring-[#064E3B] btn-glow border border-emerald-700'
  };
  const sizes = {
    sm: 'h-9 px-4 text-xs',
    md: 'h-11 px-6 text-sm',
    lg: 'h-14 px-8 text-base md:text-lg'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-140">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-141" />}
      {children}
    </button>;
}